import { render, staticRenderFns } from "./merchants-list.vue?vue&type=template&id=72a460c0&"
import script from "./merchants-list.vue?vue&type=script&lang=js&"
export * from "./merchants-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports